const PlanAdvenceSvg = () => {
  return (
    <svg
      width="226"
      height="200"
      viewBox="0 0 226 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5350_14147)">
        <path
          d="M150.372 4.51911C150.372 4.51911 113.104 -9.3632 76.9566 11.5323C40.8041 32.4324 22.9554 74.5995 7.60078 108.36C-7.75847 142.125 1.7534 176.782 29.7502 192.889C57.7424 208.992 76.3575 186.011 115.343 185.375C154.329 184.738 164.886 190.539 196.965 168.543C229.049 146.547 234.241 93.7114 208.228 54.2381C182.209 14.7648 150.372 4.51911 150.372 4.51911Z"
          fill="#0038FF"
        />
        <path
          opacity="0.7"
          d="M150.372 4.51911C150.372 4.51911 113.104 -9.3632 76.9566 11.5323C40.8041 32.4324 22.9554 74.5995 7.60078 108.36C-7.75847 142.125 1.7534 176.782 29.7502 192.889C57.7424 208.992 76.3575 186.011 115.343 185.375C154.329 184.738 164.886 190.539 196.965 168.543C229.049 146.547 234.241 93.7114 208.228 54.2381C182.209 14.7648 150.372 4.51911 150.372 4.51911Z"
          fill="white"
        />
        <g opacity="0.3">
          <path
            d="M41.6138 42.9805C48.1942 36.4001 48.1942 25.7312 41.6138 19.1508C35.0334 12.5705 24.3645 12.5705 17.7841 19.1508C11.2037 25.7312 11.2037 36.4001 17.7841 42.9805C24.3645 49.5609 35.0334 49.5609 41.6138 42.9805Z"
            stroke="#222222"
            stroke-miterlimit="10"
          />
          <path
            d="M29.6992 46.7698C38.3717 46.7698 45.4022 39.7393 45.4022 31.0668C45.4022 22.3943 38.3717 15.3639 29.6992 15.3639C21.0267 15.3639 13.9963 22.3943 13.9963 31.0668C13.9963 39.7393 21.0267 46.7698 29.6992 46.7698Z"
            stroke="#222222"
            stroke-miterlimit="10"
          />
          <path
            d="M32.6856 35.781L29.6992 31.0669H16.8247"
            stroke="#222222"
            stroke-miterlimit="10"
          />
        </g>
        <g opacity="0.3">
          <path
            d="M171.876 14.4583H154.761V49.2917H171.876V14.4583Z"
            stroke="#222222"
            stroke-miterlimit="10"
          />
          <path
            d="M191.094 14.4583H173.98V49.2917H191.094V14.4583Z"
            stroke="#222222"
            stroke-miterlimit="10"
          />
          <path
            d="M210.313 14.4583H193.198V49.2917H210.313V14.4583Z"
            stroke="#222222"
            stroke-miterlimit="10"
          />
          <path
            d="M171.876 51.0938H154.761V85.9272H171.876V51.0938Z"
            stroke="#222222"
            stroke-miterlimit="10"
          />
          <path
            d="M191.094 51.0938H173.98V85.9272H191.094V51.0938Z"
            stroke="#222222"
            stroke-miterlimit="10"
          />
          <path
            d="M210.313 51.0938H193.198V85.9272H210.313V51.0938Z"
            stroke="#222222"
            stroke-miterlimit="10"
          />
          <path
            d="M171.876 87.7294H154.761V122.563H171.876V87.7294Z"
            stroke="#222222"
            stroke-miterlimit="10"
          />
          <path
            d="M191.094 87.7294H173.98V122.563H191.094V87.7294Z"
            stroke="#222222"
            stroke-miterlimit="10"
          />
          <path
            d="M210.313 87.7294H193.198V122.563H210.313V87.7294Z"
            stroke="#222222"
            stroke-miterlimit="10"
          />
          <path
            d="M171.876 124.365H154.761V159.198H171.876V124.365Z"
            stroke="#222222"
            stroke-miterlimit="10"
          />
          <path
            d="M191.094 124.365H173.98V159.198H191.094V124.365Z"
            stroke="#222222"
            stroke-miterlimit="10"
          />
          <path
            d="M210.313 124.365H193.198V159.198H210.313V124.365Z"
            stroke="#222222"
            stroke-miterlimit="10"
          />
        </g>
        <path
          d="M8.92914 162.821H225.714"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M22.6907 116.219C22.6907 116.219 22.6907 116.172 22.7139 116.163C22.7325 116.154 22.7557 116.163 22.765 116.181C23.9772 118.977 24.8271 121.913 25.5377 124.876C26.2251 127.844 26.7221 130.858 27.0704 133.891L27.2887 136.171C27.3212 136.552 27.363 136.933 27.3909 137.314L27.4513 138.456C27.4838 139.218 27.5302 139.98 27.5534 140.746L27.5349 143.036L27.5116 144.178C27.4931 144.559 27.4652 144.94 27.442 145.321C27.3862 146.082 27.3398 146.844 27.2701 147.601C27.1261 149.12 26.8939 150.629 26.6617 152.134C26.6617 152.153 26.6431 152.167 26.6199 152.167C26.5967 152.167 26.5781 152.148 26.5781 152.125C26.5781 151.359 26.6152 150.602 26.6292 149.84C26.6524 149.083 26.7174 148.326 26.7081 147.564C26.7081 146.807 26.7267 146.05 26.7314 145.293L26.7546 144.16L26.736 143.026L26.7267 140.755L26.6663 138.489L26.6431 137.356C26.6292 136.979 26.6013 136.598 26.5781 136.222L26.4388 133.956C26.174 130.942 25.7607 127.937 25.1569 124.964C24.5531 121.996 23.81 119.042 22.7 116.219H22.6907Z"
          fill="#222222"
        />
        <path
          d="M22.3655 128.081C22.3655 128.081 22.3702 128.039 22.3888 128.029C22.412 128.02 22.4306 128.029 22.4399 128.053C23.0947 129.938 23.6149 131.866 24.0561 133.816C24.4788 135.767 24.8085 137.746 25.0082 139.738C25.208 141.721 25.4309 143.709 25.4588 145.706C25.4913 147.703 25.4588 149.701 25.2451 151.693C25.2451 151.712 25.2265 151.726 25.208 151.73C25.1847 151.73 25.1662 151.716 25.1615 151.693C24.9293 149.705 24.79 147.722 24.6506 145.739C24.5113 143.756 24.4927 141.772 24.3627 139.789C24.2419 137.815 23.9958 135.846 23.6567 133.891C23.3223 131.935 22.9089 129.989 22.3609 128.076L22.3655 128.081Z"
          fill="#222222"
        />
        <path
          d="M15.789 132.256C15.789 132.256 15.8262 132.233 15.8447 132.242C17.4889 133.282 18.9612 134.597 20.243 136.078C20.8747 136.831 21.4599 137.616 21.9615 138.47L22.3145 139.139L22.5931 139.831C22.6907 140.059 22.7603 140.295 22.8347 140.532C22.9043 140.769 22.9833 141.006 23.0483 141.243C23.5406 143.147 23.8704 145.093 23.9586 147.044C24.0376 148.995 24.0004 150.95 23.7403 152.887C23.7403 152.905 23.7217 152.919 23.7032 152.919C23.6799 152.919 23.6614 152.905 23.6614 152.882L23.1598 147.1C22.9601 145.186 22.8393 143.263 22.4259 141.396C22.3749 141.164 22.3052 140.936 22.2495 140.704C22.1891 140.472 22.1333 140.244 22.0451 140.021L21.8082 139.353L21.5063 138.721C21.0605 137.885 20.5171 137.086 19.9319 136.329C18.7568 134.815 17.3774 133.431 15.8029 132.312C15.8029 132.312 15.7797 132.274 15.7936 132.256H15.789Z"
          fill="#222222"
        />
        <path
          d="M18.9751 139.687C19.8715 140.268 20.4706 141.178 20.9769 142.093C21.4552 143.026 21.8361 144.02 22.0962 145.037C22.1751 145.288 22.2355 145.544 22.2912 145.799L22.4724 146.57C22.5653 147.086 22.6349 147.61 22.6674 148.131C22.6721 148.655 22.6907 149.18 22.6535 149.7C22.6117 150.225 22.5513 150.745 22.4492 151.261C22.4492 151.275 22.4352 151.289 22.4166 151.294C22.3934 151.294 22.3748 151.284 22.3702 151.261C22.2448 150.745 22.1612 150.235 22.0915 149.724C22.0126 149.213 21.929 148.707 21.8686 148.2C21.7943 147.694 21.7293 147.192 21.6875 146.686C21.6178 146.185 21.5806 145.674 21.4692 145.177C21.2927 144.174 21.0047 143.194 20.6099 142.26C20.2198 141.331 19.7136 140.407 18.9286 139.752H18.924C18.924 139.752 18.9054 139.71 18.9147 139.696C18.9286 139.678 18.9519 139.673 18.9704 139.682L18.9751 139.687Z"
          fill="#222222"
        />
        <path
          d="M28.199 145.483C28.4173 142.915 28.84 140.374 29.2394 137.834C29.6388 135.293 30.0847 132.757 30.5491 130.231C31.0322 127.704 31.5338 125.182 32.0772 122.67C32.0772 122.651 32.1004 122.637 32.1236 122.637C32.1468 122.637 32.1608 122.66 32.1561 122.684C31.7149 125.215 31.3201 127.755 30.9439 130.296C30.5584 132.836 30.1961 135.377 29.8757 137.922C29.5599 140.472 29.3183 143.022 28.9979 145.567L28.0597 153.212C28.0597 153.212 28.0411 153.244 28.0225 153.249C27.9993 153.249 27.9807 153.235 27.9807 153.212C27.9529 152.566 27.9529 151.925 27.9343 151.28C27.9296 150.634 27.9622 149.993 27.9714 149.348C27.9947 148.056 28.1061 146.774 28.2037 145.488L28.199 145.483Z"
          fill="#222222"
        />
        <path
          d="M29.7363 145.446C29.8757 144.429 30.0615 143.417 30.2565 142.409L30.6188 140.909C30.7349 140.407 30.851 139.91 30.995 139.413C31.5059 137.425 32.1608 135.47 32.9596 133.575L33.2661 132.869L33.6098 132.177C33.8281 131.712 34.0929 131.267 34.339 130.821C34.8778 129.948 35.4351 129.074 36.1922 128.364C36.2061 128.35 36.234 128.35 36.2479 128.364C36.2618 128.378 36.2665 128.406 36.2479 128.42C35.5466 129.149 35.0357 130.05 34.5527 130.937C34.3297 131.392 34.0929 131.843 33.9024 132.312L33.6005 133.008L33.3312 133.724C32.6206 135.623 32.0493 137.578 31.622 139.566C31.3898 140.556 31.2319 141.563 31.0414 142.557L30.7999 144.062C30.7117 144.564 30.6049 145.061 30.5352 145.562C30.3726 146.566 30.1915 147.569 30.015 148.572C29.8571 149.58 29.676 150.583 29.4623 151.591C29.4623 151.609 29.4437 151.623 29.4205 151.623C29.3973 151.623 29.3787 151.605 29.3787 151.582C29.3787 150.555 29.3973 149.529 29.4484 148.502C29.5088 147.476 29.6295 146.459 29.7363 145.437V145.446Z"
          fill="#222222"
        />
        <path
          d="M31.8635 145.576C32.3372 144.229 32.8899 142.91 33.489 141.619C34.1067 140.333 34.7709 139.069 35.5326 137.871C35.5465 137.852 35.5698 137.848 35.5883 137.857C35.6069 137.866 35.6116 137.894 35.6023 137.913C34.9335 139.162 34.3668 140.463 33.8559 141.782C33.3358 143.096 32.8667 144.429 32.4719 145.781C32.0725 147.132 31.7845 148.511 31.4222 149.872C31.046 151.228 30.7395 152.603 30.3215 153.978C30.3169 153.997 30.3029 154.006 30.2843 154.006C30.2611 154.006 30.2425 153.987 30.2425 153.964C30.224 152.529 30.3633 151.098 30.642 149.691C30.8928 148.279 31.3897 146.928 31.8635 145.581V145.576Z"
          fill="#222222"
        />
        <path
          d="M31.9517 150.063C32.1932 149.217 32.6112 148.433 33.0803 147.694C33.5448 146.951 34.0835 146.245 34.7245 145.65C35.0542 145.363 35.3979 145.089 35.7695 144.861C36.141 144.629 36.5312 144.434 36.9585 144.322C36.977 144.318 36.9956 144.322 37.0049 144.345C37.0142 144.364 37.0049 144.387 36.9863 144.396H36.9817C36.2107 144.74 35.5605 145.307 35.0124 145.929C34.4551 146.552 34.0092 147.262 33.6423 148.005C33.2522 148.744 33.0525 149.556 32.7134 150.318C32.5648 150.708 32.4162 151.098 32.2443 151.489C32.0957 151.883 31.9332 152.283 31.7288 152.673C31.7288 152.673 31.7102 152.696 31.6963 152.696C31.6731 152.696 31.6545 152.678 31.6545 152.659C31.6359 152.218 31.6638 151.781 31.7056 151.345C31.7706 150.913 31.8588 150.485 31.961 150.058L31.9517 150.063Z"
          fill="#222222"
        />
        <path
          d="M31.7892 126.343C31.7892 126.343 35.9971 125.373 36.9678 120.84C37.9385 116.307 34.8081 118.248 37.6134 111.128C40.4186 104.008 39.773 102.387 38.8023 100.339C37.8316 98.2908 37.2929 98.9364 36.429 101.635C35.5651 104.333 32.4348 108.541 31.2504 116.414C30.0615 124.291 31.7892 126.339 31.7892 126.339V126.343Z"
          fill="#0038FF"
        />
        <path
          d="M23.4849 118.685C23.4849 118.685 26.2902 117.714 26.397 112.429C26.5038 107.143 24.3488 108.221 24.0237 101.64C23.6985 95.0583 23.2666 90.4185 22.0823 90.3117C20.8933 90.2049 17.7676 93.5489 16.6901 100.887C15.6125 108.225 18.0927 113.079 20.2524 115.239C22.412 117.398 23.4895 118.689 23.4895 118.689L23.4849 118.685Z"
          fill="#0038FF"
        />
        <path
          d="M33.3033 132.706C33.3033 132.706 33.9489 128.824 35.2447 126.989C36.5405 125.155 39.3457 123.538 41.1803 119.976C43.0149 116.414 45.0631 114.691 44.9563 119.762C44.8494 124.834 42.5829 127.421 39.7777 129.149C36.9724 130.876 33.3033 132.711 33.3033 132.711V132.706Z"
          fill="#0038FF"
        />
        <path
          d="M34.4876 139.399C34.4876 139.399 37.0792 134.434 40.8552 130.77C44.6311 127.101 47.65 125.266 46.5725 127.101C45.495 128.935 44.1992 128.828 42.3646 132.066C40.5301 135.303 41.0688 137.676 38.4819 139.511C35.8902 141.345 34.4876 139.404 34.4876 139.404V139.399Z"
          fill="#0038FF"
        />
        <path
          d="M34.8127 145.762C34.9196 145.437 35.0264 143.064 38.6955 141.122C42.3647 139.181 45.8155 139.933 45.3836 140.909C44.9516 141.879 42.6851 143.5 40.4186 144.471C38.1521 145.442 34.8081 145.767 34.8081 145.767L34.8127 145.762Z"
          fill="#0038FF"
        />
        <path
          d="M23.6985 132.925C23.6985 132.925 25.3148 130.876 24.4556 126.557C23.5917 122.242 21.6503 123.32 19.4906 121.053C17.331 118.787 17.7629 118.462 15.6079 116.088C13.4482 113.715 11.5068 112.419 10.6429 113.39C9.77906 114.361 11.0749 117.384 12.3707 119.107C13.6665 120.835 15.7147 121.699 16.6854 123.854C17.6561 126.014 17.2241 129.465 19.7043 131.081C22.1844 132.697 23.6939 132.915 23.6939 132.915L23.6985 132.925Z"
          fill="#0038FF"
        />
        <path
          d="M18.3063 134.109C18.3063 134.109 14.4235 129.687 11.6183 126.45C8.813 123.213 7.73548 120.733 7.62866 122.888C7.52184 125.048 6.65797 126.771 8.92447 129.576C11.191 132.381 18.3109 134.109 18.3109 134.109H18.3063Z"
          fill="#0038FF"
        />
        <path
          d="M20.3545 141.234C20.3545 141.234 20.4613 139.506 14.3121 135.516C8.16279 131.527 5.57117 130.77 6.2214 132.386C6.86698 134.002 9.56541 135.623 12.4775 138.535C15.3896 141.447 20.3545 141.234 20.3545 141.234Z"
          fill="#0038FF"
        />
        <path
          d="M31.5338 125.884C31.5338 125.884 32.9782 118.146 34.4876 112.642C35.9971 107.139 36.9678 103.795 36.9678 103.795"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23.7311 118.764C23.7311 118.764 21.1069 110.376 20.2477 105.304C19.3838 100.232 20.3545 96.4563 20.7865 94.1898"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M33.6423 132.548C33.6423 132.548 35.2447 129.687 37.618 126.882C39.9913 124.077 41.8259 122.567 42.9034 119.869"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23.6985 132.925C23.6985 132.925 22.8346 127.746 20.7864 125.048C18.7382 122.349 14.6372 118.141 13.0162 115.448"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M35.0635 145.646C35.0635 145.646 38.6955 143.282 41.2825 141.986"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23.6892 174.233C22.0033 174.233 20.6053 172.946 20.4613 171.269C19.9225 164.865 18.7986 150.467 19.3791 149.756C21.7571 146.858 31.9982 146.858 34.3761 149.756C34.9567 150.467 33.8327 164.86 33.294 171.269C33.1546 172.946 31.752 174.233 30.0661 174.233H23.6846H23.6892Z"
          fill="#222222"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M83.6307 119.479H81.1134V129.548H83.6307V119.479Z"
          fill="#222222"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M122.491 119.479H119.974V129.548H122.491V119.479Z"
          fill="#222222"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M86.6264 86.5868H116.119C117.967 86.5868 119.467 88.087 119.467 89.9355V133.881H83.2777V89.9355C83.2777 88.087 84.7779 86.5868 86.6264 86.5868Z"
          fill="#D5D8DE"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M84.8894 174.228C85.9308 174.228 86.775 173.384 86.775 172.342C86.775 171.301 85.9308 170.457 84.8894 170.457C83.848 170.457 83.0037 171.301 83.0037 172.342C83.0037 173.384 83.848 174.228 84.8894 174.228Z"
          fill="white"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M103.295 172.342C103.295 171.302 102.45 170.457 101.41 170.457C100.369 170.457 99.524 171.302 99.524 172.342C99.524 173.383 100.369 174.228 101.41 174.228C102.45 174.228 103.295 173.383 103.295 172.342Z"
          fill="white"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M119.816 172.342C119.816 171.302 118.97 170.457 117.93 170.457C116.89 170.457 116.044 171.302 116.044 172.342C116.044 173.383 116.89 174.228 117.93 174.228C118.97 174.228 119.816 173.383 119.816 172.342Z"
          fill="white"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M103.114 162.863V131.754H99.7981V162.663L99.6773 162.747L82.53 169.667V171.715H85.2052V170.299L100.063 168.111L100.337 171.715H102.32L102.594 168.134L117.298 170.299V171.715H119.974V169.667L103.114 162.863Z"
          fill="#222222"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M106.635 135.196H96.1057V138.925H106.635V135.196Z"
          fill="#222222"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M121.153 127.082H81.5872C80.8843 127.082 80.3146 127.652 80.3146 128.354V134.141C80.3146 134.844 80.8843 135.414 81.5872 135.414H121.153C121.856 135.414 122.426 134.844 122.426 134.141V128.354C122.426 127.652 121.856 127.082 121.153 127.082Z"
          fill="#D5D8DE"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M82.2606 113.655H79.1767C78.5944 113.655 78.1224 114.127 78.1224 114.709V120.31C78.1224 120.893 78.5944 121.365 79.1767 121.365H82.2606C82.8429 121.365 83.3149 120.893 83.3149 120.31V114.709C83.3149 114.127 82.8429 113.655 82.2606 113.655Z"
          fill="#D5D8DE"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M123.406 113.655H120.322C119.74 113.655 119.268 114.127 119.268 114.709V120.31C119.268 120.893 119.74 121.365 120.322 121.365H123.406C123.988 121.365 124.46 120.893 124.46 120.31V114.709C124.46 114.127 123.988 113.655 123.406 113.655Z"
          fill="#D5D8DE"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M44.6497 125.944L156.349 125.944V115.076L44.6497 115.076V125.944Z"
          fill="white"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M44.6497 117.965L156.349 117.965V115.076L44.6497 115.076V117.965Z"
          fill="#222222"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M155.169 174.232H156.753L157.278 114.918H154.64L155.169 174.232Z"
          fill="white"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M44.0878 174.232H45.6715L46.201 114.918H43.5629L44.0878 174.232Z"
          fill="white"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M42.0906 115.944L158.88 115.944V113.492L42.0906 113.492V115.944Z"
          fill="white"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M86.4407 113.636H121.581V112.187H86.4407V113.636Z"
          fill="white"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M113.685 106.999H155.964V78.51H113.685V106.999Z"
          fill="#222222"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M122.816 113.636H139.926V112.029H122.816V113.636Z"
          fill="#D5D8DE"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M129.727 113.636H139.926V95.1929H129.727V113.636Z"
          fill="#D5D8DE"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M97.9821 16.7572L102.747 17.9462"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M105.724 7.22681L107.118 10.4036"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M133.921 16.7572L129.156 17.9462"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M126.179 7.22681L124.785 10.4036"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M116.249 3.05603V7.02705"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M120.457 25.735L119.486 19.725C119.486 19.725 118.998 15.6565 118.998 14.3189C118.998 12.9813 118.511 12.8605 118.33 13.1067L117.781 13.4086C117.781 13.4086 117.6 11.8294 117.113 12.3171C116.625 12.8048 116.565 13.4689 116.565 13.4689C116.565 13.4689 116.017 14.4396 115.775 15.6565C115.673 16.1627 115.594 16.9755 115.534 17.7651L115.227 17.3564C115.227 17.3564 115.046 15.3546 114.986 14.9273C114.925 14.5 114.256 14.9877 114.196 16.5064C114.15 17.6908 114.842 20.7282 115.148 22.0008C114.986 23.3663 114.842 25.0662 115.046 25.8557C115.408 27.2537 116.137 28.164 116.383 28.5263C116.63 28.8886 118.083 32.8364 118.083 32.8364L122.454 30.895L120.452 25.735H120.457Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M118.817 23.306C118.817 23.306 117.54 20.9373 117.298 20.5146C117.057 20.0874 115.599 18.3271 115.232 17.3564C114.869 16.3857 114.019 17.7187 114.382 18.7544C114.744 19.7855 116.202 21.6711 116.202 21.6711C116.202 21.6711 115.715 23.3106 116.383 24.7086C117.052 26.1066 118.385 26.7104 118.385 26.7104"
          fill="white"
        />
        <path
          d="M118.817 23.306C118.817 23.306 117.54 20.9373 117.298 20.5146C117.057 20.0874 115.599 18.3271 115.232 17.3564C114.869 16.3857 114.019 17.7187 114.382 18.7544C114.744 19.7855 116.202 21.6711 116.202 21.6711C116.202 21.6711 115.715 23.3106 116.383 24.7086C117.052 26.1066 118.385 26.7104 118.385 26.7104"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M117.781 13.4086C117.781 13.4086 117.354 18.1459 117.54 19.9666"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M116.569 13.469C116.569 13.469 116.142 17.2357 116.388 18.8148"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M152.606 56.8807C152.606 56.8807 145.123 54.2752 144.622 54.2752C144.12 54.2752 138.881 53.899 138.881 53.899L132.686 50.6618L122.7 30.3887L116.815 33.245C116.815 33.245 118.915 44.0898 120.596 50.058C122.277 56.0261 124.195 59.463 124.195 59.463L137.558 69.4068L138.231 70.3311L152.606 56.8807Z"
          fill="#0038FF"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M131.427 81.4268C131.427 81.4268 128.654 93.5302 128.654 100.005C128.654 106.479 128.821 108.16 129.244 108.411C129.662 108.662 134.455 109.503 134.878 109.419C135.3 109.335 136.559 108.913 136.559 108.913C136.559 108.913 142.694 79.8291 143.368 76.2157C144.041 72.6023 144.966 64.702 144.966 64.702C144.966 64.702 137.906 70.7538 135.969 72.8577C134.032 74.9617 134.204 75.0453 133.364 76.6383C132.523 78.2314 131.432 81.4314 131.432 81.4314L131.427 81.4268Z"
          fill="#0038FF"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M134.627 173.88C134.627 173.88 132.374 177.604 131.98 177.995C131.585 178.385 128.157 180.447 127.177 180.739C126.197 181.032 125.12 181.622 125.12 182.602C125.12 183.582 128.352 184.074 130.02 184.074C131.687 184.074 136.587 183.782 137.172 183.782C137.757 183.782 138.84 183.684 139.327 183.782C139.819 183.879 142.267 184.274 142.955 183.977C143.642 183.684 144.227 181.232 144.032 180.154C143.837 179.077 143.247 176.624 143.247 176.624L134.622 173.88H134.627Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M164.616 177.604L162.949 180.349C162.949 180.349 160.757 182.323 159.517 183.094C156.512 184.971 160.794 186.071 162.749 185.937C164.124 185.844 166.669 185.839 167.454 185.444C168.239 185.054 171.471 182.894 172.749 181.914C174.021 180.935 174.119 179.857 173.924 178.584C173.729 177.312 172.846 175.352 172.846 175.352C172.846 175.352 167.654 173.684 166.181 174.86C164.709 176.035 164.612 177.604 164.612 177.604H164.616Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M135.881 106.075L133.656 117.756C133.656 117.756 129.764 142.121 129.876 143.008C129.987 143.899 134.664 169.063 134.776 170.062C134.887 171.06 133.772 172.064 133.772 172.064L133.995 174.511C133.995 174.511 136.777 176.401 138.668 176.847C140.558 177.293 143.451 177.405 143.451 177.405C143.451 177.405 144.455 175.291 144.455 174.957C144.455 174.623 143.786 172.398 143.786 172.064C143.786 171.729 142.002 142.339 142.002 142.339L146.34 125.54C146.34 125.54 152.239 143.338 152.791 144.564C153.349 145.785 164.077 172.978 164.077 172.978C164.077 172.978 163.074 174.311 163.409 175.315C163.743 176.318 164.189 178.208 164.189 178.208C164.189 178.208 166.637 175.426 167.858 176.318C169.08 177.21 169.303 178.208 169.303 178.208L173.195 176.652C173.195 176.652 173.529 175.096 173.306 174.316C173.083 173.536 172.526 174.539 172.526 171.646C172.526 168.752 168.694 151.461 167.914 148.795C167.134 146.124 163.91 141.117 163.91 141.117L162.466 114.193V107.965L135.876 106.075H135.881Z"
          fill="#222222"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M154.589 58.237C154.589 58.237 151.719 57.3266 150.548 57.8468C149.378 58.367 139.75 68.5895 139.62 69.2397C139.49 69.8899 134.715 101.881 133.935 104.347C133.155 106.813 137.442 109.935 137.442 109.935L140.038 111.105L142.244 108.509L142.114 111.625C142.114 111.625 148.867 111.755 150.948 111.495C153.024 111.235 161.077 109.159 161.077 109.159C161.077 109.159 162.768 81.1017 162.898 80.5815C163.028 80.0613 164.328 62.2684 164.328 62.2684L161.862 60.7078L154.589 58.2416V58.237Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M154.552 66.0025L156.368 69.6345C156.368 69.6345 161.644 63.9264 162.248 62.5424C162.851 61.1583 163.372 61.0701 163.028 60.2062C162.684 59.3423 161.816 58.4785 161.816 58.4785C161.816 58.4785 153.771 58.2184 152.736 58.7386C151.7 59.2587 148.844 65.7424 148.672 66.179L148.5 66.6109L153.948 65.6588L154.552 66.0025Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M152.104 58.9847C152.104 58.9847 134.283 75.5422 133.359 76.6383C132.435 77.7344 131.427 81.4314 131.427 81.4314C131.427 81.4314 133.025 74.3718 133.614 73.2757C134.204 72.1842 146.809 59.2401 146.809 59.2401L150.172 56.8854L153.618 57.726L152.104 58.9847Z"
          fill="#0038FF"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M154.032 36.682C154.032 36.682 150.483 40.4022 150.571 41.0942C150.66 41.7862 150.483 42.7383 150.483 42.7383C150.483 42.7383 146.763 45.7665 146.419 45.8501C146.076 45.9384 146.076 46.5422 146.331 47.0623C146.591 47.5825 147.023 47.6661 147.195 48.0981C147.367 48.53 147.283 49.7422 146.591 52.162C145.899 54.5817 145.555 54.9301 146.247 55.362C146.939 55.7939 151.955 57.5263 151.955 57.5263C151.955 57.5263 152.127 64.7903 152.476 65.8306C152.819 66.8663 154.552 66.0025 154.552 66.0025L161.816 59.0822V57.87L167.524 51.038C167.524 51.038 169.08 45.4182 167.352 42.7337C165.624 40.0538 156.54 36.2454 156.279 36.1618C156.019 36.0735 154.807 35.9017 154.032 36.682Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M160.348 34.5223C160.348 34.5223 161.82 33.6584 160.868 33.2265C159.916 32.7945 158.88 33.1382 158.62 33.2265C158.36 33.3147 158.88 30.6302 157.408 31.4105C155.936 32.1907 154.036 34.0903 153.604 35.3908C153.172 36.6912 154.468 39.1946 155.592 39.3711C156.716 39.5429 159.224 40.4068 159.224 40.4068C159.224 40.4068 159.916 40.927 159.484 41.8791C159.052 42.8312 156.544 44.7355 156.888 45.251C157.232 45.7712 158.1 46.9787 158.1 46.9787C158.1 46.9787 157.236 48.5346 157.408 48.9666C157.58 49.3985 158.1 49.5703 158.1 49.5703C158.1 49.5703 159.656 48.6182 160.956 48.9666C162.257 49.3149 161.737 51.4746 161.217 52.4267C160.696 53.3788 160.004 54.5028 160.004 54.5028C160.004 54.5028 161.477 57.8746 161.82 57.8746C162.164 57.8746 166.404 53.6389 168.22 51.7347C170.036 49.8304 170.817 46.5468 170.385 43.7787C169.953 41.0106 165.369 37.2904 163.896 36.4265C162.424 35.5626 160.348 34.5223 160.348 34.5223Z"
          fill="#222222"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M148.152 44.2107C147.371 43.6905 147.98 41.2707 148.672 41.0106C149.364 40.7506 150.488 42.7384 150.488 42.7384C150.488 42.7384 154.208 45.5947 154.292 46.1103C154.38 46.6305 152.304 48.1863 151.18 48.2746C150.056 48.3628 149.624 48.3628 149.624 46.7187C149.624 45.0746 150.228 43.9506 150.228 43.9506"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M154.292 46.1102L158.964 49.3103"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M152.044 42.7384C152.044 42.7384 153.771 42.9102 154.463 44.4661"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M147.98 50.2625C147.98 50.2625 149.536 50.9545 151.352 50.2625"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M160 54.5028C160 54.5028 158.184 54.9347 157.32 54.5028"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M151.955 57.5263L155.244 57.3545L152.044 60.3827L151.955 57.5263Z"
          fill="#222222"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M163.028 60.2108C163.028 60.2108 161.286 63.2065 159.591 69.1839C157.896 75.166 156.112 93.2841 156.112 95.2487C156.112 97.2133 160.664 120.775 161.021 121.666C161.379 122.558 163.608 122.646 163.608 122.646C163.608 122.646 170.213 118.183 170.57 116.934C170.928 115.684 166.377 94.7099 166.377 94.7099C166.377 94.7099 174.676 67.5769 174.142 67.2193C173.608 66.8617 163.032 60.2108 163.032 60.2108H163.028Z"
          fill="#0038FF"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M166.107 63.2019C166.107 63.2019 160.576 85.3374 159.233 89.1738C157.896 93.0101 156.108 95.2441 156.108 95.2441"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M164.259 118.824C164.259 118.824 163.423 120.11 162.972 120.621C162.522 121.137 161.3 121.713 161.881 122.098C162.461 122.484 163.999 121.778 164.384 121.197L164.254 118.819L164.259 118.824Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M167.761 113.84C167.761 113.84 164.389 117.092 164.198 117.412C164.008 117.733 163.813 120.431 163.813 121.202C163.813 121.973 164.328 122.423 164.584 122.488C164.839 122.554 165.355 122.554 165.355 122.554L166.191 122.423C166.191 122.423 166.962 122.358 167.733 122.554C168.504 122.744 170.046 122.744 170.431 122.363C170.817 121.978 171.202 121.016 171.202 121.016C171.202 121.016 171.653 120.501 171.778 119.73C171.908 118.959 172.679 115.104 172.679 115.104C172.679 115.104 167.217 113.227 167.765 113.845L167.761 113.84Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M165.35 122.549L165.931 118.954"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M167.022 122.358L167.663 119.275"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M168.95 122.484L169.526 119.595"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M174.137 67.2194C174.137 67.2194 183.236 87.3438 184.485 90.4696C185.735 93.5953 184.755 94.7239 184.485 95.5274C184.216 96.3309 173.914 115.8 173.914 115.8L167.756 113.836L174.1 93.4234L169.405 84.5293L174.137 67.2147V67.2194Z"
          fill="#0038FF"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M124.734 32.1165C124.734 32.1165 124.795 29.6828 125.236 28.243C125.672 26.8079 125.361 26.1809 125.05 26.3063C124.739 26.4317 124.363 26.4921 124.177 27.616C123.991 28.74 123.926 29.302 123.926 29.9894C123.926 30.6767 124.739 32.1119 124.739 32.1119L124.734 32.1165Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M117.986 25.0197C118.097 24.8247 118.808 25.591 119.3 26.0415C119.105 25.6421 119.054 25.6189 118.738 24.9315C118.362 24.1187 118.432 23.6496 118.487 23.4313C118.655 22.7811 119.988 24.2255 120.378 24.9779C120.178 24.3741 119.769 23.1201 119.676 22.7439C119.551 22.2423 119.616 21.5596 119.988 21.3088C120.364 21.058 120.926 22.3724 120.926 22.3724C120.926 22.3724 121.739 22.7486 122.05 23.3709L124.172 27.616L124.358 30.6117L126.295 37.9824L130.791 44.2292L125.83 46.6397L122.923 39.7334C122.923 39.7334 122.175 39.111 121.613 38.2332C121.204 37.5969 120.828 35.2375 120.605 33.3287C120.494 33.0128 120.331 32.502 120.224 31.8703C120.043 30.8067 119.714 28.3173 119.714 28.3173C119.714 28.3173 118.761 27.1794 118.246 26.4131C117.944 25.9579 117.842 25.2752 117.99 25.0197H117.986Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M120.489 25.3076C120.489 25.3076 121.344 26.6452 121.655 27.4023C121.91 28.0246 122.133 28.9396 122.133 28.9396"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M120.926 22.3723C120.926 22.3723 122.551 26.1808 122.923 26.7428C123.299 27.3047 123.485 28.4937 123.485 28.8049"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M119.305 26.0415C119.305 26.0415 120.517 27.1794 120.666 27.5092C120.814 27.8389 121.288 29.6363 121.288 29.6363"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M158.648 152.984C158.648 152.984 159.28 161.771 158.411 166.044C157.543 170.317 154.375 176.648 154.059 177.521C153.744 178.389 151.05 188.124 151.129 188.524C151.208 188.923 153.107 192.323 152.87 193.985C152.634 195.648 152.239 196.122 151.524 196.28C150.813 196.438 147.409 196.359 145.114 198.258C142.82 200.158 139.415 199.763 138.226 199.684C137.037 199.605 133.954 199.605 133.796 198.974C133.638 198.342 135.458 196.916 136.406 196.521C137.353 196.127 139.889 193.99 140.6 193.275C141.31 192.56 144.004 189.081 144.557 187.734C145.11 186.387 146.693 165.812 147.167 162.645C147.641 159.477 147.957 155.919 147.878 153.941C147.799 151.962 148.272 150.852 148.272 150.852L158.639 152.989L158.648 152.984Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M136.41 196.517C136.763 196.368 137.33 195.983 137.943 195.523C138.607 195.82 139.536 196.201 139.973 196.201C140.683 196.201 145.908 192.717 147.729 191.691C149.206 190.86 151.301 190.646 152.044 190.6C152.527 191.751 153.001 193.112 152.875 193.99C152.638 195.653 152.243 196.127 151.528 196.284C150.818 196.442 147.413 196.363 145.119 198.263C142.824 200.163 139.42 199.768 138.231 199.689C137.042 199.61 133.958 199.61 133.8 198.978C133.642 198.347 135.463 196.921 136.41 196.526V196.517Z"
          fill="#0038FF"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M184.555 150.653C184.555 150.653 187.346 155.492 188.554 160.234C189.761 164.981 189.576 185.263 189.761 185.635C189.947 186.006 191.624 189.917 192.46 191.589C193.296 193.266 195.344 195.774 195.344 196.521C195.344 197.269 193.853 197.264 193.575 197.264H188.456C188.456 197.264 187.063 196.8 186.78 196.243C186.501 195.685 186.315 193.266 185.665 192.522C185.015 191.779 183.431 189.824 183.338 188.802C183.245 187.78 183.895 184.618 183.895 183.87C183.895 183.122 181.847 174.846 181.197 172.705C180.547 170.563 177.291 164.981 176.915 160.332C176.539 155.683 176.172 153.634 176.172 153.634L184.546 150.657L184.555 150.653Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M187.778 184.622C188.833 184.929 189.757 186.048 190.277 186.777C190.885 188.161 191.879 190.418 192.465 191.589C193.301 193.265 195.349 195.773 195.349 196.521C195.349 197.269 193.858 197.264 193.579 197.264H188.461C188.461 197.264 187.068 196.8 186.784 196.243C186.506 195.685 186.32 193.265 185.67 192.522C185.019 191.779 183.436 189.824 183.343 188.802C183.287 188.194 183.496 186.833 183.673 185.672C183.961 185.384 185.521 183.967 187.774 184.627L187.778 184.622Z"
          fill="#0038FF"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M193.584 197.264H188.466C188.466 197.264 187.072 196.8 186.789 196.243C186.51 195.685 186.325 193.265 185.674 192.522C185.126 191.895 183.919 190.414 183.496 189.346L183.747 189.081C183.747 189.081 186.25 187.065 188.085 188.166C189.919 189.267 190.407 191.83 191.568 193.112C192.729 194.394 194.675 195.346 195.353 196.521C195.353 197.264 193.862 197.264 193.584 197.264Z"
          fill="#222222"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M186.311 75.728C186.311 75.728 189.209 91.5935 189.297 92.1137C189.385 92.6339 191.731 100.376 191.387 102.118C191.039 103.86 183.816 118.559 183.816 118.559C183.816 118.559 181.991 115.513 181.726 115.341C181.462 115.169 182.423 100.641 182.423 100.641L179.553 91.3334C179.553 91.3334 179.534 81.8448 180.774 80.0288C182.014 78.2128 185.814 74.8224 186.311 75.7327V75.728Z"
          fill="#0038FF"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M180.472 93.3119C180.472 93.3119 184.587 92.2576 186.882 89.9633"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M182.386 96.5631C182.386 96.5631 185.544 98.5742 188.795 98.5742"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M187.188 111.583C185.442 115.248 183.816 118.559 183.816 118.559C183.816 118.559 181.991 115.512 181.726 115.341C181.629 115.276 181.699 113.297 181.824 110.812C183.928 112.257 185.837 112.08 187.188 111.583Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M178.87 102.903C178.87 102.903 182.929 113.362 184.509 117.454C186.092 121.546 186.324 143.393 186.324 143.393L185.86 151.581C185.86 151.581 176.743 155.864 166.321 155.395C155.899 154.93 146.967 151.953 146.967 151.953C146.967 151.953 147.014 132.994 149.341 126.669C151.667 120.343 153.339 113.92 153.339 113.92L154.12 104.115L178.87 102.907V102.903Z"
          fill="#222222"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M183.993 80.8509C183.826 81.2642 179.808 94.3755 179.808 94.3755C179.808 94.3755 178.852 97.5059 178.763 97.8543C178.675 98.2026 178.935 102.29 179.023 102.638C179.112 102.986 179.748 102.057 179.488 103.279C179.228 104.496 178.095 104.584 177.398 104.932C176.701 105.281 171.397 107.194 165.828 107.106C160.26 107.018 153.999 105.889 153.999 105.889C153.999 105.889 153.042 104.148 152.87 103.367C152.699 102.582 153.186 100.813 153.186 100.813L150.85 82.0909C150.85 82.0909 141.166 69.2908 139.843 68.3805C138.519 67.4701 136.787 66.1511 136.29 65.7378C135.793 65.3244 135.296 64.4977 134.966 63.5874C134.636 62.6771 125.826 46.6397 125.826 46.6397C125.826 46.6397 128.055 44.2432 128.636 44.076C129.216 43.9088 130.535 43.7462 130.535 43.7462L141.988 56.5603C141.988 56.5603 144.218 57.6332 144.715 57.884C145.212 58.1301 145.128 59.5374 145.128 59.5374L148.611 61.0979L160.302 64.7903L165.884 66.1372C165.884 66.1372 181.671 72.0868 182.66 72.5837C183.654 73.0807 186.38 74.8966 186.297 75.7234C186.213 76.5501 184.727 79.9359 184.727 79.9359"
          fill="#0038FF"
        />
        <path
          d="M183.993 80.8509C183.826 81.2642 179.808 94.3755 179.808 94.3755C179.808 94.3755 178.852 97.5059 178.763 97.8543C178.675 98.2026 178.935 102.29 179.023 102.638C179.112 102.986 179.748 102.057 179.488 103.279C179.228 104.496 178.095 104.584 177.398 104.932C176.701 105.281 171.397 107.194 165.828 107.106C160.26 107.018 153.999 105.889 153.999 105.889C153.999 105.889 153.042 104.148 152.87 103.367C152.699 102.582 153.186 100.813 153.186 100.813L150.85 82.0909C150.85 82.0909 141.166 69.2908 139.843 68.3805C138.519 67.4701 136.787 66.1511 136.29 65.7378C135.793 65.3244 135.296 64.4977 134.966 63.5874C134.636 62.6771 125.826 46.6397 125.826 46.6397C125.826 46.6397 128.055 44.2432 128.636 44.076C129.216 43.9088 130.535 43.7462 130.535 43.7462L141.988 56.5603C141.988 56.5603 144.218 57.6332 144.715 57.884C145.212 58.1301 145.128 59.5374 145.128 59.5374L148.611 61.0979L160.302 64.7903L165.884 66.1372C165.884 66.1372 181.671 72.0867 182.66 72.5837C183.654 73.0807 186.38 74.8966 186.297 75.7234C186.213 76.5501 184.727 79.9359 184.727 79.9359"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M160.023 92.476C162.568 95.8803 165.968 99.9907 168.847 101.946"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M156.238 87.0698C156.238 87.0698 157.441 88.9369 159.229 91.3985"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M172.047 101.217C172.498 101.528 172.948 101.811 173.376 102.034"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M166.065 95.8572C166.065 95.8572 168.541 98.5417 171.114 100.53"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M143.075 59.9554C143.075 59.9554 139.271 64.3352 139.355 63.0115C139.439 61.6878 139.025 61.6878 140.265 60.6986"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M165.545 42.8823C165.545 42.8823 160.905 45.6458 160.511 46.5329C160.116 47.42 159.921 49.5936 159.424 50.0859C158.931 50.5782 156.07 51.2702 156.168 51.9623C156.265 52.6543 157.352 54.7257 157.352 54.7257C157.352 54.7257 157.157 61.3394 157.157 61.8318C157.157 62.3241 157.747 62.6213 158.342 62.7188C158.931 62.8164 160.315 63.2112 160.315 63.2112V64.7903C160.315 64.7903 164.166 66.0721 164.561 66.0721C164.955 66.0721 167.519 66.2672 167.519 66.2672C167.519 66.2672 172.749 62.8117 174.425 57.8793C176.102 52.9469 174.425 49.0966 172.549 46.8255C170.673 44.5543 165.54 42.8777 165.54 42.8777L165.545 42.8823Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M166.335 56.2074C166.335 56.2074 169.59 53.5414 170.38 55.7151C171.17 57.884 170.478 59.0684 169.493 59.4631C168.508 59.8579 166.14 60.6475 166.14 60.6475C166.14 60.6475 163.869 65.8771 163.673 68.0508C163.478 70.2244 162.094 71.901 162.786 73.378C163.478 74.8595 164.463 75.4494 169.298 75.9417C174.133 76.434 179.641 75.7234 183.097 74.2418C186.552 72.7602 186.074 67.5492 185.386 66.3648C184.694 65.1805 181.439 61.0376 181.536 58.864C181.634 56.695 184.597 53.351 182.493 47.3364C180.635 42.0232 171.564 38.7302 169.098 39.0275C166.632 39.3247 164.458 39.0275 164.458 40.6066C164.458 42.1857 164.556 43.7648 166.233 45.9338C167.909 48.1028 166.925 49.7841 166.53 50.1788C166.135 50.5736 164.853 51.8555 165.048 53.4346C165.243 55.0137 166.33 56.1981 166.33 56.1981L166.335 56.2074Z"
          fill="#222222"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M160.631 56.7925C160.631 56.7925 160.288 58.2741 158.007 57.8189"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M162.113 48.9248C162.113 48.9248 161.885 47.8427 160.743 47.8427"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M160.153 50.1973C159.93 50.6478 159.884 51.0798 160.051 51.168C160.218 51.2516 160.538 50.9544 160.766 50.5039C160.994 50.0533 161.035 49.6214 160.868 49.5332C160.701 49.4449 160.381 49.7468 160.153 50.1973Z"
          fill="#222222"
        />
        <path
          d="M65.8982 45.5993C65.8982 45.5993 66.1536 45.0884 65.3873 44.3175C64.6209 43.5465 61.2026 41.4147 60.1762 40.7319C59.1497 40.0492 57.9561 37.9127 53.8551 40.3882C49.754 42.8637 47.023 47.3085 46.5075 50.4667C45.9966 53.625 48.0448 57.4706 51.8904 59.607C55.7361 61.7435 58.7225 62.0825 58.7225 62.0825L59.1497 62.8535L71.2764 61.0608C71.2764 61.0608 73.241 59.0125 72.9856 57.8143C72.7302 56.616 70.5937 52.6032 70.5937 52.6032C70.5937 52.6032 71.9592 50.555 71.5319 49.9558C71.1046 49.3567 65.8935 45.5993 65.8935 45.5993H65.8982Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M60.8589 55.9333C60.8589 55.9333 59.1497 56.5324 58.467 56.7878C57.7843 57.0433 55.8197 56.4442 54.9651 54.7396C54.1105 53.0351 55.3924 51.2377 56.3306 51.0659C57.2687 50.894 58.0397 51.4932 58.5506 51.4096C59.0615 51.326 59.0615 50.7268 59.1497 50.2159C59.2333 49.705 57.7843 48.7622 57.7843 48.7622C57.7843 48.7622 59.7489 46.6258 60.2598 45.6876C60.7707 44.7494 56.7578 43.8066 56.586 43.0402C56.4142 42.2739 60.1715 40.7319 60.1715 40.7319C59.1451 40.0492 57.9515 37.9127 53.8504 40.3882C49.7493 42.8637 47.0184 47.3085 46.5029 50.4667C45.992 53.625 48.0402 57.4706 51.8858 59.607C54.4031 61.005 56.5488 61.632 57.7332 61.9014L58.6342 61.3998C58.6342 61.3998 59.0615 60.8889 60.0879 59.3516C61.1144 57.8143 60.8589 55.9333 60.8589 55.9333Z"
          fill="#222222"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M65.3037 45.2556C65.3037 45.2556 64.1936 45.0838 63.3391 46.6211"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M70.5983 54.3076C70.5983 54.3076 68.9774 54.9904 66.8409 53.114"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M65.7588 47.759C66.0561 48.3489 66.0932 48.9294 65.8378 49.0595C65.587 49.1849 65.1411 48.8133 64.8439 48.2235C64.5466 47.6336 64.5095 47.0531 64.7649 46.923C65.0157 46.7976 65.4616 47.1692 65.7588 47.759Z"
          fill="#222222"
        />
        <path
          d="M69.4883 61.827C69.4883 61.827 59.3262 60.9725 58.7271 62.0825C58.1279 63.1925 58.2162 65.4126 58.2162 65.4126L69.4047 62.8488L69.4883 61.8224V61.827Z"
          fill="#0038FF"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M86.0273 57.0247C86.0273 57.0247 106.802 34.3551 106.927 34.0253C107.053 33.6955 107.68 26.3712 107.745 25.865C107.805 25.3541 107.643 24.5645 108.256 23.775C108.869 22.99 110.035 21.1508 110.035 21.1508C110.035 21.1508 110.959 19.2002 111.265 18.8054C111.572 18.4106 112.334 17.8161 112.826 17.2727C113.323 16.7293 114.061 16.302 114.456 16.6086C114.851 16.9151 115.037 18.197 115.037 18.197C115.037 18.197 115.557 18.2062 115.715 19.0005C115.877 19.7947 114.6 23.9422 114.549 24.3648C114.498 24.7875 114.112 28.6981 113.653 31.0528C113.197 33.4076 112.482 35.0424 111.776 35.9017C111.07 36.7609 103.551 47.7265 101.661 49.8211C99.7703 51.9158 92.302 64.9249 92.302 64.9249L86.0319 57.0247H86.0273Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M109.524 22.089C109.524 22.089 108.488 24.9871 108.441 25.3819C108.395 25.7767 108.13 27.9642 108.13 27.9642"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M111.781 18.4106C111.781 18.4106 110.439 22.1587 110.29 22.7439C110.137 23.3291 110.002 24.1187 110.002 24.1187"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M115.032 18.2017C115.032 18.2017 114.628 19.5253 114.024 20.8629C113.42 22.2005 112.877 24.676 112.863 24.7922"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M113.666 16.8268C113.666 16.8268 112.092 20.8303 111.869 21.6895C111.646 22.5488 111.344 24.0443 111.237 24.2347"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M80.5282 71.1067L93.1704 105.945L90.328 109.925L87.3416 104.342L84.9915 92.4434L80.5282 71.1067Z"
          fill="#222222"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M53.2605 96.8046C53.2605 96.8046 52.0065 101.821 52.875 102.499C53.7435 103.172 61.6577 105.587 61.8481 105.299C62.0432 105.011 61.9457 101.825 61.7506 100.957C61.5555 100.088 60.1111 98.9317 60.1111 98.9317L53.2605 96.8092V96.8046Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M55.476 82.2349C55.476 82.2349 52.968 94.9746 53.1584 95.4577C53.3535 95.9407 59.8186 96.7117 59.8186 96.7117L55.476 82.2349Z"
          fill="#0038FF"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M52.68 93.0425C52.68 93.0425 51.909 97.0971 52.875 97.5802C53.8411 98.0632 59.6281 99.6051 60.1111 98.9317C60.5941 98.2583 59.9161 95.3601 59.9161 95.3601C59.9161 95.3601 53.163 92.2715 52.68 93.0425Z"
          fill="#0038FF"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M79.5621 188.194C79.5621 188.194 82.7065 190.548 83.6028 190.776C84.4992 190.999 87.6435 192.011 87.9779 192.573C88.3123 193.135 87.9779 194.928 87.5274 195.602C87.0769 196.275 80.6815 197.283 77.6533 196.949C74.6251 196.614 68.0021 198.184 67.3286 196.052C66.6552 193.92 67.7791 190.776 67.7791 190.776C67.7791 190.776 77.5418 188.644 79.5621 188.194Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M85.6232 195.04C84.3877 195.374 79.4507 195.602 73.6172 195.825C69.9017 195.969 68.0114 195.249 67.1243 194.705C67.1382 195.17 67.2032 195.629 67.3333 196.052C68.0067 198.184 74.6297 196.614 77.6579 196.948C80.6861 197.283 87.0862 196.275 87.532 195.602C87.7085 195.332 87.8711 194.886 87.9779 194.413C87.1837 194.622 86.2362 194.872 85.6232 195.04Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M38.3797 181.459C38.3797 181.459 35.6859 187.07 36.1364 188.305C36.5869 189.541 37.9338 189.764 39.1646 190.214C40.3954 190.665 43.5397 190.548 44.4407 191.11C45.3417 191.672 49.6007 193.581 51.621 193.916C53.6414 194.25 55.7732 193.354 55.9961 192.457C56.219 191.561 52.7403 188.867 51.3934 187.971C50.0466 187.074 47.9147 183.93 47.9147 183.93L38.375 181.459H38.3797Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M42.8662 189.652C40.3675 189.053 36.8981 187.567 36.1689 187.246C36.076 187.706 36.0528 188.078 36.1364 188.305C36.5869 189.541 37.9338 189.764 39.1646 190.214C40.4 190.665 43.5397 190.548 44.4407 191.11C45.3417 191.672 49.6007 193.581 51.621 193.916C53.6414 194.25 55.7732 193.354 55.9961 192.457C56.0426 192.281 55.9358 192.025 55.7314 191.733C54.7932 192.299 53.516 192.954 52.5174 193.015C50.72 193.126 45.6715 190.321 42.8662 189.647V189.652Z"
          fill="white"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M60.6034 110.338C60.6034 110.338 58.128 119.86 58.0165 122.553C57.905 125.247 58.1279 127.941 58.1279 127.941C58.1279 127.941 56.3305 129.288 56.6696 130.412C57.004 131.536 57.566 132.321 57.566 132.321C57.566 132.321 53.3023 148.59 52.7404 149.38C52.1784 150.169 46.2335 159.365 44.659 162.51C43.0892 165.654 39.3829 178.77 39.3829 178.77C39.3829 178.77 38.598 179.555 38.4865 180.34C38.375 181.125 38.1521 182.472 38.1521 182.472C38.1521 182.472 39.3875 184.943 42.7548 185.388C46.122 185.839 47.9148 185.165 47.9148 185.165C47.9148 185.165 48.4767 184.381 48.6997 183.257C48.9226 182.133 49.2617 180.34 49.2617 180.34L55.5456 169.453L65.9817 150.276L69.126 141.298C69.126 141.298 70.5844 154.54 70.4729 155.102C70.3615 155.664 67.4447 165.752 67.4447 170.689C67.4447 175.626 67.7792 185.95 67.7792 185.95C67.7792 185.95 66.8828 187.52 67.1057 188.421L67.3286 189.318L67.7792 190.776C67.7792 190.776 72.1542 190.665 74.1746 190.325C76.1949 189.991 79.5622 188.194 79.5622 188.194C79.5622 188.194 79.8966 186.624 79.5622 186.062C79.2278 185.5 78.7772 184.938 78.6658 184.381C78.5543 183.819 78.2153 182.472 78.5543 180.902C78.8887 179.332 82.3674 155.775 83.7143 149.83C85.0612 143.881 85.3956 124.695 85.2841 121.216C85.1727 117.737 84.7222 115.266 84.7222 115.266L84.9451 111.226C84.9451 111.226 78.6611 108.532 73.2735 108.197C67.886 107.863 61.3791 108.871 61.3791 108.871L60.5988 110.343L60.6034 110.338Z"
          fill="#222222"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M62.7306 128.503L66.8827 135.238L68.6755 140.509"
          stroke="#BABDD5"
          stroke-miterlimit="10"
        />
        <path
          d="M70.4218 128.327C71.2067 127.63 71.9824 126.882 72.2657 126.599C72.8276 126.037 73.6126 118.294 73.724 117.96"
          stroke="#BABDD5"
          stroke-miterlimit="10"
        />
        <path
          d="M62.1686 118.963C62.1686 118.963 62.1686 124.797 62.8421 126.032C63.5155 127.268 67.8906 129.961 68.5641 129.734"
          stroke="#BABDD5"
          stroke-miterlimit="10"
        />
        <path
          d="M63.4041 116.386C63.4041 116.386 69.4651 115.378 73.3897 116.72"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M78.3964 146.198C78.545 149.491 78.6797 154.127 78.3267 155.325C77.7647 157.234 77.4303 157.568 77.0913 158.469C76.7569 159.366 77.2028 160.378 76.9798 160.94C76.7569 161.502 76.0835 171.367 75.5215 173.945C74.9595 176.527 74.848 182.137 74.848 182.137"
          stroke="#BABDD5"
          stroke-miterlimit="10"
        />
        <path
          d="M80.3471 112.907C80.3471 112.907 79.5622 122.781 79.2231 125.925C78.8887 129.07 77.7647 133.891 77.8762 135.911C77.9877 137.931 78.2106 142.757 78.2106 142.757C78.2106 142.757 78.2385 143.189 78.2756 143.899"
          stroke="#BABDD5"
          stroke-miterlimit="10"
        />
        <path
          d="M75.0756 183.591V186.173C75.0756 186.173 75.972 186.396 75.7491 187.297C75.5261 188.194 74.7412 188.867 74.7412 188.867"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M58.2115 65.4126C58.2115 65.4126 54.5377 69.4254 53.5996 74.0373C52.6614 78.6493 55.8196 84.8868 55.8196 84.8868L61.1143 104.445C61.1143 104.445 59.577 105.638 59.4934 106.665C59.4098 107.691 59.8371 110.083 60.6034 110.338C61.3744 110.594 73.3293 110.51 73.3293 110.51C73.3293 110.51 85.2005 112.647 85.456 112.647C85.7114 112.647 87.0769 111.453 87.0769 110.083C87.0769 108.713 86.8214 106.753 86.7332 105.898C86.6449 105.044 83.2313 82.5831 82.8876 81.0458C82.5439 79.5085 82.4231 73.4336 82.4231 73.4336L89.5756 68.1249L90.7971 66.5504L85.3259 57.7167C85.3259 57.7167 76.5618 59.8578 76.1345 60.2015C75.7072 60.5452 58.1976 65.4126 58.1976 65.4126H58.2115Z"
          fill="#0038FF"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M83.3195 58.7664C83.3195 58.7664 89.1019 69.2722 89.4502 69.2304C89.7986 69.1886 93.0125 66.8199 93.2401 66.3322C93.4723 65.8446 93.0869 64.7671 93.0869 64.7671C93.0869 64.7671 87.0723 56.8993 86.5289 56.4024C85.9855 55.9054 85.3631 56.0912 85.1495 56.407C84.9358 56.7228 82.9248 56.9969 83.3149 58.7664H83.3195Z"
          fill="#0038FF"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M82.4324 73.4336L71.1835 81.8308"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M69.27 94.4498C68.6894 95.4577 68.0903 96.3912 67.4726 97.1993"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M75.057 80.8601C75.057 80.8601 73.6869 86.0619 70.027 93.0704"
          stroke="#222222"
          stroke-miterlimit="10"
        />
        <path
          d="M70.9838 94.8632C70.9838 94.8632 66.827 101.096 64.881 102.782"
          stroke="#222222"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_5350_14147">
          <rect
            width="225.428"
            height="200"
            fill="white"
            transform="translate(0.285767)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export default PlanAdvenceSvg
